(() => {
  const root = document.querySelector('[data-bs-navigation]');
  if (!root) return;

  const drawer = root.querySelector('#bs-nav-drawer');
  const mega = root.querySelector('[data-bs-mega]');
  const megaInner = root.querySelector('.bs-nav__mega-inner');
  const openButtons = root.querySelectorAll('[data-bs-drawer-open]');
  const closeButtons = root.querySelectorAll('[data-bs-drawer-close]');
  const megaButtons = root.querySelectorAll('[data-bs-mega-open]');
  const megaPanels = root.querySelectorAll('[data-bs-mega-panel]');
  const megaCards = root.querySelectorAll('[data-bs-mega-card]');
  const tabButtons = root.querySelectorAll('[data-bs-tab]');
  const panels = root.querySelectorAll('[data-bs-panel]');
  const sceneButtons = root.querySelectorAll('[data-bs-scene]');
  const subScenes = root.querySelectorAll('[data-bs-sub-scene]');

  const setDrawer = (open) => {
    root.classList.toggle('is-drawer-open', open);
    drawer?.setAttribute('aria-hidden', open ? 'false' : 'true');
    openButtons.forEach((button) => button.setAttribute('aria-expanded', open ? 'true' : 'false'));
    document.documentElement.classList.toggle('bs-nav-lock', open);
  };

  openButtons.forEach((button) => button.addEventListener('click', () => setDrawer(true)));
  closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tab = button.dataset.bsTab;
      tabButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.bsPanel === tab);
        if (panel.dataset.bsPanel === tab) panel.scrollTop = 0;
      });
    });
  });

  sceneButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const scene = button.dataset.bsScene;
      const hasScene = Array.from(subScenes).some((pane) => pane.dataset.bsSubScene === scene);
      sceneButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      subScenes.forEach((pane) => pane.classList.toggle('is-active', pane.dataset.bsSubScene === (hasScene ? scene : 'default')));
    });
  });

  const closeMega = () => {
    mega?.classList.remove('is-open');
    mega?.setAttribute('aria-hidden', 'true');
    megaButtons.forEach((button) => button.classList.remove('is-active'));
    megaPanels.forEach((panel) => panel.classList.remove('is-active'));
    megaCards.forEach((card) => card.classList.remove('is-active'));
    mega?.classList.remove('has-active-card');
  };

  const normalizeLink = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return `${url.pathname.replace(/\/$/, '') || '/'}${url.search}`;
    } catch (_error) {
      return value.replace(/\/$/, '');
    }
  };

  const fitMegaToViewport = () => {
    if (!mega || !window.matchMedia('(min-width: 990px)').matches) return;
    // offsetTop avoids the entrance animation's translated position.
    const top = root.getBoundingClientRect().top + mega.offsetTop;
    let bottom = window.visualViewport
      ? Math.min(window.innerHeight, window.visualViewport.offsetTop + window.visualViewport.height)
      : window.innerHeight;
    const previewBar = document.getElementById('PBarNextFrameWrapper');
    if (previewBar) {
      const bar = previewBar.getBoundingClientRect();
      if (bar.height > 0 && bar.width > 0 && bar.top > 0 && bar.top < bottom) bottom = bar.top;
    }
    const available = Math.max(0, Math.floor(bottom - Math.max(0, top) - 16));
    mega.style.setProperty('--bs-mega-available-height', `${available}px`);
  };
  window.addEventListener('resize', fitMegaToViewport, { passive: true });
  window.addEventListener('scroll', () => {
    if (mega?.classList.contains('is-open')) fitMegaToViewport();
  }, { passive: true });
  window.visualViewport?.addEventListener('resize', fitMegaToViewport, { passive: true });

  const openMega = (button) => {
    fitMegaToViewport();
    const activeKey = button.dataset.bsMegaOpen || '';
    const changed = mega?.dataset.active !== activeKey;
    const activeUrl = normalizeLink(button.dataset.bsMegaUrl);
    mega?.classList.add('is-open');
    mega?.setAttribute('aria-hidden', 'false');
    mega?.setAttribute('data-active', activeKey);
    megaButtons.forEach((item) => item.classList.toggle('is-active', item === button));
    megaPanels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.bsMegaPanel === activeKey));
    const activeCards = Array.from(megaCards).filter((card) => {
      const targetUrl = normalizeLink(card.dataset.bsMegaCardUrl);
      return targetUrl ? targetUrl === activeUrl : card.dataset.bsMegaCard === activeKey;
    });
    megaCards.forEach((card) => card.classList.toggle('is-active', activeCards.includes(card)));
    mega?.classList.toggle('has-active-card', activeCards.length > 0);
    if (changed && megaInner) megaInner.scrollTop = 0;
  };

  megaButtons.forEach((button) => {
    button.addEventListener('mouseenter', () => openMega(button));
    button.addEventListener('focus', () => openMega(button));
    button.addEventListener('click', () => openMega(button));
  });

  document.addEventListener('click', (event) => {
    if (!mega?.classList.contains('is-open')) return;
    const target = event.target;
    if (target.closest?.('[data-bs-mega-open]') || megaInner?.contains(target)) return;
    const interactiveTarget = target.closest?.('a, button, input, select, textarea, label, [role="button"]');
    closeMega();
    if (!interactiveTarget) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest?.('[data-bs-mega-card]');
    if (!card) return;
    const targetUrl = normalizeLink(card.dataset.bsMegaCardUrl);
    const button = Array.from(megaButtons).find((item) => {
      return targetUrl
        ? normalizeLink(item.dataset.bsMegaUrl) === targetUrl
        : item.dataset.bsMegaOpen === card.dataset.bsMegaCard;
    });
    if (button) openMega(button);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setDrawer(false);
      closeMega();
    }
  });
})();

(() => {
  if (window.bsMobileHeaderLayoutInstalled) return;
  window.bsMobileHeaderLayoutInstalled = true;
  const layouts = new Map();

  function initialize(scope) {
    scope.querySelectorAll('[data-bs-navigation]').forEach((nav) => {
      const header = nav.closest('.section-header');
      const type = header?.querySelector('sticky-header')?.dataset.stickyType;
      if (!header || !['always', 'reduce-logo-size'].includes(type) || layouts.has(header)) return;

      const oldHeight = header.style.getPropertyValue('--bs-nav-fixed-height');
      const measure = () => {
        const height = `${nav.offsetHeight}px`;
        if (nav.offsetHeight > 0 && header.style.getPropertyValue('--bs-nav-fixed-height') !== height) {
          header.style.setProperty('--bs-nav-fixed-height', height);
        }
      };
      measure();
      header.classList.add('bs-fixed-mobile-header');
      // Size changes only; scroll and Safari toolbar changes never toggle visibility.
      const observer = new ResizeObserver(measure);
      observer.observe(nav);
      layouts.set(header, { observer, oldHeight });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    layouts.forEach((layout, header) => {
      if (event.target !== header && !event.target.contains(header)) return;
      layout.observer.disconnect();
      header.classList.remove('bs-fixed-mobile-header');
      if (layout.oldHeight) header.style.setProperty('--bs-nav-fixed-height', layout.oldHeight);
      else header.style.removeProperty('--bs-nav-fixed-height');
      layouts.delete(header);
    });
  });
})();
